import { useState, useCallback, useEffect } from 'react';
import { showToast } from '@attentive-platform/stem-ui';
import { fetchApiData } from '../Utils/ApiCalls';
import { GET_TRADES } from '../urls';

export const useTradeData = () => {
  const [loading, setLoading] = useState(false);
  const [tradesData, setTradesData] = useState([]);
  const [workflowOptions, setWorkflowOptions] = useState([]);

  const handleApiResponse = useCallback(response => {
    setTradesData(response.trades.map(tradeInfo => ({ label: tradeInfo.display_name, value: tradeInfo.id })));
    setWorkflowOptions(
      Object.keys(response.workflow_options).map(workflow => ({
        label: workflow.toUpperCase(),
        value: workflow
      }))
    );
  }, []);

  const getTradesData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchApiData({
        endpoint: GET_TRADES,
        apiRequest: 'GET'
      });

      if (response.error) {
        throw new Error(response.error);
      }

      if (response.data) {
        handleApiResponse(response.data);
      }
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setLoading(false);
    }
  }, [handleApiResponse]);

  useEffect(() => {
    getTradesData();
  }, [getTradesData]);

  return { loading, tradesData, workflowOptions };
};
